import { defineComponent as u } from "vue";
import i from "./component-library19.js";
import { useLabeledInput as r } from "./component-library257.js";
const m = /* @__PURE__ */ u({
  __name: "radio-input",
  props: {
    label: { default: void 0 },
    labelClass: { default: void 0 },
    id: { default: void 0 },
    errorMessage: { default: void 0 },
    required: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    showLabel: { type: Boolean },
    large: { type: Boolean },
    medium: { type: Boolean },
    idPrefix: { default: void 0 },
    placeholder: { default: void 0 },
    inputClass: { default: void 0 },
    maxlength: { default: void 0 },
    inputProps: { default: void 0 },
    value: { default: void 0 },
    name: { default: void 0 },
    checked: { type: Boolean, default: !1 },
    val: { default: "" }
  },
  emits: ["input", "focus"],
  setup(d, { expose: p, emit: e }) {
    const o = d, { inputWrapperProps: n, onInput: a, focus: t } = r(o, e), l = () => {
      e("input", o.val);
    };
    return p({ focus: t, onChange: l, onInput: a }), { __sfc: !0, props: o, emits: e, inputWrapperProps: n, onInput: a, focus: t, onChange: l, InputWrapper: i };
  }
});
export {
  m as default
};
